import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { DEFAULT_MODEL } from '@whelk/const/src/models';

interface LocalState {
  hasShownSelectModelTip?: boolean | undefined;
  hasShownVL01Tip: boolean;
  isShowVl01: boolean;
  model: string;
}

const initialState: LocalState = {
  hasShownSelectModelTip: false,
  hasShownVL01Tip: false,
  isShowVl01: false, // 默认不展示 需要判断refer

  model: DEFAULT_MODEL, // 当前选择的模型
};

export const localSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setSelectedModel: (state, action: PayloadAction<string>) => {
      state.model = action.payload || DEFAULT_MODEL;
    },
    setSelectModelTip: (state, action: PayloadAction<LocalState['hasShownSelectModelTip']>) => {
      state.hasShownSelectModelTip = action.payload;
    },
    setVL01Tip: (state, action: PayloadAction<LocalState['hasShownVL01Tip']>) => {
      state.hasShownVL01Tip = action.payload;
    },
    setShowVl01: (state, action: PayloadAction<LocalState['isShowVl01']>) => {
      state.isShowVl01 = action.payload;
    },
  },
});

export const { setSelectedModel, setSelectModelTip, setVL01Tip, setShowVl01 } = localSlice.actions;

export default localSlice.reducer;
